import { render, staticRenderFns } from "./AccomodationsTable.vue?vue&type=template&id=8a203e12"
import script from "./AccomodationsTable.vue?vue&type=script&lang=ts"
export * from "./AccomodationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports